import { GetTransactionCountsRequest, CountData } from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

export default function useTransactionCount() {
  const source = axios.CancelToken.source();
  const [fetching, setFetching] = useState(false);
  const [counts, setCounts] = useState<CountData>({});

  useEffect(() => {
    return () => source.cancel();
  }, []);

  async function fetchTransactionCount(params: GetTransactionCountsRequest) {
    try {
      setFetching(true);
      const res = await api.fetchTransactionCounts(params, source);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setCounts(res.CountData);

      return res;
    } finally {
      setFetching(false);
    }
  }

  return {
    fetching,
    counts,
    fetchTransactionCount,
  };
}
